
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Si cela prend `}<strong parentName="p">{`trois jours`}</strong>{`, l'effet sur la propagation du Sars-CoV-2 est
`}<strong parentName="p">{`pratiquement nul`}</strong>{` `}<em parentName="p">{`(voir graphique)`}</em>{`. Si, en revanche, une `}<strong parentName="p">{`action
immédiate`}</strong>{` est entreprise, l'effet est `}<strong parentName="p">{`très net`}</strong>{`. La contribution d'une
application de `}<em parentName="p">{`proximity tracing`}</em>{` est décisive, explique l'épidémiologiste Adam
Kucharski dans cet
`}<a parentName="p" {...{
        "href": "https://cmmid.github.io/topics/covid19/reports/bbc_contact_tracing.pdf"
      }}>{`article`}</a>{`.`}</p>
    <p>{`«Il se pourrait même, qu'un jour, le `}<em parentName="p">{`proximity tracing`}</em>{` suffise pour garder
l'épidémie sous contrôle», ajoute l'épidémiologiste et professeur à l'EPFL
Marcel Salathé.`}</p>
    <p>{`Il estime que pour obtenir l'effet recherché, il faudrait que `}<strong parentName="p">{`60% de la
population suisse`}</strong>{` installe une telle application. Même si pratiquement tous
les Suisses utilisent un smartphone chaque jour, c'est un objectif ambitieux.`}</p>
    <p>{`Une application similaire de `}<em parentName="p">{`proximity tracing`}</em>{` est utilisée à Singapour depuis
le 18 mars. Mais elle n'a été installée que par 20% de la population – c'est
insuffisant. Près de 40 pays dans le monde `}<strong parentName="p">{`ont eux aussi de telles
applications`}</strong>{` en service ou en projet, mais beaucoup d'entre elles démontrent
des faiblesses, soit parce qu'elles présentent des problèmes techniques, soit
parce qu'elles ne garantissent pas une bonne protection de la vie privée.`}</p>
    <p>{`Marcel Salathé, l'une des chevilles ouvrières de l'application suisse de
`}<em parentName="p">{`proximity tracing`}</em>{`, est convaincu que la voie suisse est la bonne: «On peut
construire un système de contact `}<em parentName="p">{`tracing digital`}</em>{` qui soit suffisant d'un point
de vue épidémiologique, sans pour autant mettre en danger la vie privée.» La
Commission nationale d'éthique et le Préposé fédéral à la protection des données
ont déjà donné leur feu vert.`}</p>
    <p>{`Au bout du compte, une telle application a simplement pour but de soutenir le
travail des spécialistes du `}<em parentName="p">{`contact tracing`}</em>{` sur le terrain. «Ces experts
savent ce qu'il faut faire, qui doit faire un test de dépistage à quel endroit
et qui doit être mis en quarantaine», dit le professeur Salathé.`}</p>
    <h3>{`Quand puis-je installer cette app?`}</h3>
    <p>{`L'app helvétique `}<strong parentName="p">{`est disponible officiellement depuis le 25 juin`}</strong>{`. On peut
les télécharger depuis
l'`}<a parentName="p" {...{
        "href": "https://www.apple.com/ch-fr/search/swisscovid?src=serp"
      }}>{`App Store d'Apple`}</a>{` ou
le
`}<a parentName="p" {...{
        "href": "https://play.google.com/store/apps/details?id=ch.admin.bag.dp3t&hl=fr_CH"
      }}>{`Google Play Store`}</a>{`.
L'OFSP a travaillé en étroite collaboration avec l'EPFL et l'ETH Zurich. La
conception de l'application est basée sur le
`}<a parentName="p" {...{
        "href": "https://github.com/DP-3T/documents"
      }}>{`concept DP-3T`}</a>{`. Avec ce modèle
décentralisé, il n'est pas possible de reconstituer qui a rencontré qui à quel
moment – ni où. Les données de chaque utilisateur sont uniquement stockées sur
son propre smartphone. Il n'y a donc pas de base de données centralisée. Une
vidéo de 30 minutes du youtubeur de l'EPFL Lê Nguyên Hoang
(`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=RKZOBSdkUBo"
      }}>{`Science4all`}</a>{`) explique de manière
détaillée et accessible les subtilités de ce système. L'OFSP répond également à
de nombreuses questions sur
`}<a parentName="p" {...{
        "href": "https://www.bag.admin.ch/bag/fr/home/krankheiten/ausbrueche-epidemien-pandemien/aktuelle-ausbrueche-epidemien/novel-cov/faq-kontakte-downloads/haeufig-gestellte-fragen.html?faq-url=/fr/categories/application-swisscovid"
      }}>{`son site internet`}</a>{`.`}</p>
    <p>{`Après avoir hésité de longues semaines, les gouvernement allemands et
britanniques se sont finalement décidés en faveur de cette solution, déjà
adoptée par l'Autriche et les Pays-Bas notamment. Les autorités françaises
elles, ont lancé mi-juin leur solution centralisée, faiant de la France un îlot
d'incompatibilité en Europe.`}</p>
    <p>{`Les apps basées sur le standard DP-3T sont en effet interopérables, permettant à
un Suisse qui aurait passé des vacances en Italie de recevoir des notifications
de contact.`}</p>
    <p>{`Lisez également:
`}<a parentName="p" {...{
        "href": "https://www.tdg.ch/comment-une-idee-suisse-a-convaincu-apple-et-google-701125237692"
      }}>{`Application «Swisscovid» – Comment une idée suisse a convaincu Apple et Google`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;